import * as XLSX from 'xlsx';

/**
 * Télécharge un classeur XLSX depuis le navigateur.
 *
 * XLSX.writeFile() choisit son mode selon qu'il détecte un module `fs` façon
 * Node (`typeof require !== 'undefined'` puis `require('fs')`) — sous le bundle
 * webpack 5 de cette application, cela peut se résoudre vers autre chose au
 * lieu de retomber proprement sur le chemin Blob du navigateur, et produire un
 * fichier que XLSX.read() ne sait pas relire. XLSX.write(...) suivi d'un Blob
 * et d'une ancre contourne entièrement cette détection d'environnement.
 *
 * @param {Object} workbook classeur construit avec XLSX.utils
 * @param {String} filename nom du fichier, extension comprise
 */
export function downloadWorkbook(workbook, filename) {
	const arrayBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
	const blob = new Blob([arrayBuffer], {
		type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
	});
	const url = URL.createObjectURL(blob);
	const link = document.createElement('a');
	link.href = url;
	link.download = filename;
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
	URL.revokeObjectURL(url);
}

/**
 * Rend un intitulé utilisable comme nom de fichier. Les caractères interdits
 * par Windows sont remplacés plutôt que retirés, faute de quoi « Prix A/B »
 * deviendrait « Prix AB ».
 * @param {String} label
 * @returns {String}
 */
export function toFileNameFragment(label) {
	return String(label || '')
		.replace(/[\\/:*?"<>|]/g, '-')
		.replace(/\s+/g, ' ')
		.trim()
		.slice(0, 60);
}
